module.exports = __webpack_public_path__ + "img/uy.3b6078d1.svg";